import {AutoComplete, Button, Card, DatePicker, Form, Icon, Input, Select, Spin, Tooltip} from 'antd';
import React, {Component} from 'react';
import {sanitizeFieldName} from '../../util/methods';
import moment from 'moment';
import DocumentList from '../../components/DocumentList';
import Table from 'antd/es/table';
import SubList from '../../components/SubList';
import MasterModal from "../../components/MasterModal";
import {isParent} from "../../appRedux/actions";
import IotTicketPicker from './IotTicketPicker';
import './style.css';

const {Option} = AutoComplete;

class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      documentData: [],
      mainTableDataSource: [],
      childAssetFilter: [],
      assetTableDataSource: [],
      moveTo: '',
      from: '',
      meterVisible: false,
      parentAssetCode: '',
      toMeterVisible: false,
      parentAssetId: null,
      showDetails: false,
      toParentId: null,
      disableJobCard: false,
      showIotOpsTicket: false,
    };
  }

  // The IoT Ops Ticket field is shown when the sub-asset being transferred is an IoT
  // device, i.e. its assetModel is flagged as a tag / fuel-sensor / RFID / BLE device.
  hasIotDevice = (assetModel) => !!(assetModel &&
    (assetModel.isTagDevice || assetModel.isFuelSensorDevice || assetModel.isRfidTag || assetModel.isBleTag));

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const {roles} = user;
    const isDisableJobCard = (roles || []).findIndex(item => item.disableSATJobCard);
    this.setState({
      disableJobCard: isDisableJobCard >= 0,
      organisationId: user.organisation && user.organisation._id,
    })
  }

  // The asset whose Ops tickets are relevant: the Primary Asset when transferring to
  // stock, otherwise the To Asset (stock->asset and asset->asset). Returns its code.
  getTicketAssetCode = () => {
    const {data, parentAssets} = this.props;
    const {moveTo, parentAssetCode, toParentId} = this.state;
    if(moveTo === 'stock') {
      return parentAssetCode || (data && data.fromParent && data.fromParent.assetCode);
    }
    if(data && data.toParent && data.toParent.assetCode) {
      return data.toParent.assetCode;
    }
    const selected = (parentAssets || []).find(asset => asset._id === toParentId);
    return selected && selected.assetCode;
  };

  // Fill the field from a picked Ops ticket and clear any stale job card error.
  handleTicketSelected = (ticketNo) => {
    this.props.form.setFieldsValue({iotOpsTicket: ticketNo});
    this.handleIotOpsTicketChange();
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.data.assets !== this.props.data.assets) {
      if(this.props.title === 'EDIT') {
        const assetTableDataSource = nextProps && nextProps.data && nextProps.data.assets && nextProps.data.assets.length > 0 ? nextProps.data.assets : [];
        this.setState({assetTableDataSource}, () => {
          this.state.assetTableDataSource.forEach((item) => {
            this.pushToAssetTable(item._id);
          });
        });
        nextProps.data && nextProps.data.moveTo && this.setState({
          moveTo: nextProps.data.moveTo,
        });
      }
    }

    // Show the IoT Ops Ticket field on an existing record as soon as the fetched
    // asset (with its populated assetModel) arrives -- independent of the assets
    // array guard above, which does not fire for the singular `asset`.
    if(nextProps.data && nextProps.data.asset && nextProps.data.asset !== this.props.data.asset) {
      this.setState({
        showIotOpsTicket: this.hasIotDevice(nextProps.data.asset.assetModel),
      });
    }

    if(nextProps.childAssets !== this.props.childAssets) {
      this.setState({assetTableDataSource: nextProps.childAssets});
    }

  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      const {documentData} = this.state;
      const data = Object.assign({}, values);
      if(documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      data.fromParent = this.state.parentAssetId;
      // Drop the optional IoT Ops Ticket when empty so we don't persist a blank/"undefined" string.
      if(!data.iotOpsTicket) {
        delete data.iotOpsTicket;
      }
      /*this.state.mainTableDataSource.forEach((item, index, array) => {
        this.state.assetTableDataSource.filter(asset => asset.assetCode === item.assetCode).map(item => data.assets.push(item._id));
      });*/

      if(match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  pushToAssetTable = (data) => {
    // console.log(data);
    if(this.state.moveTo && this.state.moveTo === 'asset') {
      let dataSet = {
        from: this.state.from ? this.state.from : '',
        moveTo: this.state.moveTo ? this.state.moveTo : '',
        asset: data ? data : null,
      };
      this.props.form.setFieldsValue({toParent: ''});
      this.props.fetchToAssetsList(dataSet);
    }

    let item = this.state.assetTableDataSource.find(item => item._id === data);
    let mainTableDataSource = [...this.state.mainTableDataSource];
    mainTableDataSource[0] = {
      key: item._id,
      assetCode: item.assetCode,
      rate: item.rate,
      parent: item.parent && item.parent.assetCode,
      assetModel: item.assetModel && item.assetModel.name,
      location: item.location && item.location.name,
      description: item.description,
    };

    const prevParentId = this.state.parentAssetId;
    this.setState({
      mainTableDataSource: mainTableDataSource,
      meterVisible: true,
      parentAssetCode: item.parent && item.parent.assetCode,
      parentAssetId: item.parent && item.parent._id,
      showIotOpsTicket: this.hasIotDevice(item.assetModel),
    });

    this.props.form.setFieldsValue({fromParentJobCard: ''});
    if(item.parent && item.parent._id !== prevParentId) {
      this.props.fetchJobCards(item.parent._id, 'from');
    }
  };

  /*popFromAssetTable(data) {
    let index = this.state.mainTableDataSource.findIndex(item => item.assetCode === data);
    index >= 0 && this.state.mainTableDataSource.splice(index, 1);
    this.setState({
      mainTableDataSource: this.state.mainTableDataSource,
    });
  }*/

  showMeter = async (value) => {
    const allowMeter = await isParent(value);
    // console.log(allowMeter, value, this.state.toParentId);
    if(allowMeter === true) {
      this.setState({toMeterVisible: true});
    } else {
      this.setState({toMeterVisible: false});
    }
    if(value !== this.state.toParentId) {
      this.props.fetchJobCards(value, 'to');
    }
    this.props.form.setFieldsValue({toParentJobCard: ''});

    this.setState({toParentId: value});
  };

  /*handleSearch = (assetSearchQuery) => {
    this.props.fetchAssetWithParentKey(assetSearchQuery);
  };*/

  onSearch = (element) => {
    const arr = this.props.childAssets.filter((item) => {
      if(this.state.mainTableDataSource.findIndex(b => b.assetCode === item.assetCode) >= 0) {
        return false;
      }
      return !!item.assetCode.toLowerCase().includes(element.toLowerCase());

    });
    this.setState({childAssetFilter: arr});
  };

  /*onParentSearch = (element, options) => {
    return !!options.props.children.toLowerCase().includes(element.toLowerCase());
  };*/

  handleMoveDropdown = (value) => {
    this.props.clearProps();
    let data = {
      from: this.state.from ? this.state.from : '',
      moveTo: value ? value : ''
    };
    this.props.form.setFieldsValue({asset: '', toParent: ''});
    this.props.fetchAssetsList(data);
    this.setState({
      moveTo: value, meterVisible: false, parenAssetCode: ''
    });
  };

  handleModalCancel = () => {
    this.setState({showDetails: false});
  };

  handleFromSelect = (value) => {
    this.props.clearProps();
    this.props.form.setFieldsValue({asset: '', moveTo: '', toParent: ''});
    this.setState({
      from: value,
      meterVisible: false,
      parentAssetCode: ''
    });
  };

  handleSearchJobCards = (asset, direction) => {
    if(asset) {
      this.props.fetchJobCards(asset, direction);
    }
  };

  // Validation rules for a job card field:
  //  - role makes it optional (disableJobCard)      -> no rule (both fields optional)
  //  - IoT Ops Ticket also visible                  -> either job card OR ticket required
  //  - otherwise                                    -> job card required
  jobCardRules = (label) => {
    const {disableJobCard, showIotOpsTicket} = this.state;
    if(disableJobCard) {
      return [];
    }
    if(showIotOpsTicket) {
      return [{validator: this.jobCardOrTicketValidator(label)}];
    }
    return [{required: true, message: `Job Card is required!`}];
  };

  // Either-or validator used when the IoT Ops Ticket field is visible: the job card
  // is satisfied by either its own value or by an entered IoT Ops Ticket.
  jobCardOrTicketValidator = (label) => (rule, value, callback) => {
    const iotOpsTicket = this.props.form.getFieldValue('iotOpsTicket');
    if(value || iotOpsTicket) {
      callback();
    } else {
      callback(`${label} or IoT Ops Ticket is required!`);
    }
  };

  // When the ticket changes, re-run the job card validators so a previously shown
  // "required" error clears once the ticket satisfies the either-or rule.
  handleIotOpsTicketChange = () => {
    setTimeout(() => {
      this.props.form.validateFields(['fromParentJobCard', 'toParentJobCard'], {force: true}, () => {});
    }, 0);
  };

  // Rendered inline right after the visible job card so the two fields sit together
  // as a group. Only one instance is mounted at a time (see the guards at each call site).
  renderIotOpsTicketField = () => {
    if(!this.state.showIotOpsTicket) {
      return null;
    }
    const {data, filters, form} = this.props;
    const ticketAssetCode = this.getTicketAssetCode();
    return (
      <Form.Item key={'iotOpsTicket'} label={
        <span>IoT Ops Ticket&nbsp;
          <Tooltip title={(filters['iotOpsTicket'] && filters['iotOpsTicket'].options && filters['iotOpsTicket'].options.description) ||
            'Optional IoT Ops ticket used to track the sub-asset transfer on AssetPro Operation App'}>
            <Icon type="question-circle-o"/>
          </Tooltip>
          <IotTicketPicker
            assetCode={ticketAssetCode}
            orgId={this.state.organisationId}
            disabled={!ticketAssetCode}
            onSelect={this.handleTicketSelected}
          />
        </span>}>
        {form.getFieldDecorator('iotOpsTicket', {
          initialValue: data && data.iotOpsTicket,
        })(
          // Read-only: the value can only be set by picking a ticket from the popup.
          <Input readOnly allowClear placeholder={'Select using "Pick Ticket"'} onChange={this.handleIotOpsTicketChange}/>
        )}
      </Form.Item>
    );
  };

  // Renders a job card field together with the IoT Ops Ticket. When both are on
  // screen they are boxed as one group with a hint, so it is clear to the user that
  // either one satisfies the requirement. When only one is present, it renders plainly.
  renderJobCardWithTicket = (jobCardElement, showTicket) => {
    const ticket = showTicket ? this.renderIotOpsTicketField() : null;
    if(jobCardElement && ticket) {
      return (
        <div className="sat-field-group">
          <div className="sat-field-group__hint">
            <Icon type="info-circle"/>
            {this.state.disableJobCard
              ? <span>Optionally add a Job Card <b>or</b> an IoT Ops Ticket — both are optional.</span>
              : <span>Enter <b>either</b> a Job Card <b>or</b> an IoT Ops Ticket — one of the two is required.</span>}
          </div>
          {jobCardElement}
          {ticket}
        </div>
      );
    }
    return <React.Fragment>{jobCardElement}{ticket}</React.Fragment>;
  };

  render() {

    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, fromJobCards, toJobCards, jobCardsLoading} = this.props;
    const {mainTableDataSource, moveTo} = this.state;
    // Whether the "to" group (which holds the Asset Job Card) is on screen. The IoT
    // Ops Ticket is grouped with the "to" job card when present, otherwise with the
    // "from" job card, so it always sits directly beneath a job card field.
    const toGroupVisible = title === 'EDIT' || moveTo === 'asset';
    const columns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        key: 'rate',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Primary Asset',
        dataIndex: 'parent',
        key: 'parent',
      },
      {
        title: 'Asset Model',
        dataIndex: 'assetModel',
        key: 'assetModel',
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
      }
    ];

    const editColumns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        key: 'rate',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Primary Asset',
        dataIndex: 'parent',
        key: 'parent',
        render: (value) => value && value.assetCode
      },
      {
        title: 'Asset Model',
        dataIndex: 'assetModel',
        key: 'assetModel',
        render: (value) => value && value.name
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        render: (value) => value && value.name
      }
    ];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Form.Item key={'attachedDate'} label={'Transfer Date'}>
              {getFieldDecorator('attachedDate', {
                rules: [{required: true, message: `Transfer Date is required!`}],
                initialValue: data && data['attachedDate'] && moment(data['attachedDate']),
                //})(<DatePicker disabled={this.props.title === 'EDIT'}/>)}
              })(<DatePicker/>)}
            </Form.Item>
            {title === 'EDIT' && <Form.Item key={'subAssetTransferNo'} label={'Sub Asset Transfer No.'}>
              {
                getFieldDecorator('subAssetTransferNo', {
                  initialValue: data && data['subAssetTransferNo'],
                })(<Input disabled={true}/>)
              }
            </Form.Item>
            }
            <Form.Item key={'fromWhere'} label={'From'}>
              {getFieldDecorator('fromWhere', {
                rules: [{required: true, message: `From Field is required!`}],
                initialValue: data && data['fromWhere'],
              })(
                <Select onSelect={this.handleFromSelect} disabled={title === 'EDIT'}>
                  <Select.Option value={'asset'}>Asset</Select.Option>
                  <Select.Option value={'stock'}>Stock</Select.Option>
                </Select>,
              )}

            </Form.Item>

            {title === 'EDIT' || this.state.from ? <Form.Item key={'moveTo'} label={'Move To'}>
              {getFieldDecorator('moveTo', {
                rules: [{required: true, message: `Move To Field is Required!`}],
                initialValue: data && data.moveTo,
              })(
                <Select onSelect={this.handleMoveDropdown} disabled={title === 'EDIT'}>
                  <Select.Option value={'asset'}> Asset </Select.Option>
                  {this.state.from !== 'stock' ? <Select.Option value={'stock'}> Stock </Select.Option> : ''}
                </Select>
              )}
            </Form.Item> : ''}

            {(title === 'EDIT') || (this.state.from && this.state.moveTo) ?
              <Form.Item key={'asset'} label={'Select Asset To Transfer'}>
                {getFieldDecorator('asset', {
                  rules: [{required: true, message: `Asset is Required`}],
                  initialValue: data && data.asset && data.asset.assetCode,
                })(
                  <Select
                    showSearch
                    mode="single"
                    onSelect={this.pushToAssetTable}
                    placeholder="Search Asset"
                    disabled={title === 'EDIT'}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {this.props.childAssets && this.props.childAssets.map(item =>
                      <Option key={item._id} value={item._id}>{item.assetCode}</Option>)}
                  </Select>
                )}
              </Form.Item> : ''}

            {title === 'EDIT' || (this.state.meterVisible && this.state.from !== 'stock') ?
              (<>
                <Form.Item key={'fromParent'} label={'Primary Asset'}>
                  {getFieldDecorator('fromParent', {
                    initialValue: title === 'CREATE' ? this.state.parentAssetCode && this.state.parentAssetCode : title !== 'CREATE' ?
                      data && data['fromParent'] && data['fromParent'].assetCode : '',
                  })(<Input disabled={true} placeholder={'Primary Asset Code'}/>)
                  }
                </Form.Item>

                {/* Job card + ticket grouped together; ticket pairs with the "from"
                    job card only when the "to" group is not shown. */}
                {this.renderJobCardWithTicket(
                  (
                    <Form.Item key={'fromParentJobCard'} label={'Parent Asset Job Card'}>
                      {getFieldDecorator('fromParentJobCard', {
                        rules: this.jobCardRules('Parent Asset Job Card'),
                        initialValue: data && data.fromParentJobCard && data.fromParentJobCard.jobCardNo,
                      })(
                        <Select
                          loading={this.props.jobCardsLoading}
                          disabled={title === 'EDIT'}
                        >
                          {
                            this.props.fromJobCards && this.props.fromJobCards.map(jc =>
                              <Option key={jc._id} value={jc._id}>{jc.jobCardNo}</Option>)
                          }
                        </Select>,
                      )}
                    </Form.Item>
                  ),
                  !toGroupVisible,
                )}
              </>)
              : ''}

            {title === 'CREATE' ? Object.keys(filters).length && this.state.meterVisible && this.state.from !== 'stock' &&
              <SubList key={'from.readings'} item={filters['from.readings']} form={form}
                       data={data['from'] && data['from']['readings']} title={title} resource={resource}/> :
              Object.keys(filters).length &&
              <SubList key={'from.readings'} item={filters['from.readings']} form={form}
                       data={data['from'] && data['from']['readings']} title={title} resource={resource}/>
            }

            {title === 'CREATE' ? this.state.meterVisible && <Form.Item key={'assetDetail'} label={'Asset Details'}>
              {getFieldDecorator('assetDetail', {
                initialValue: (data && data['assetDetail']) ? data['assetDetail'] : [],
              })(<Table columns={columns} dataSource={mainTableDataSource} pagination={false}/>)
              }
            </Form.Item> : <Form.Item key={'assetDetail'} label={'Asset Details'}>
              {getFieldDecorator('assetDetail', {})
              (<Table columns={editColumns} dataSource={data && data['assetDetail']} pagination={false}/>)
              }
            </Form.Item>}

            {(title === 'EDIT' || moveTo === 'asset') ? <><Form.Item key={'toParent'} label={'To Asset'}>
                {getFieldDecorator('toParent', {
                  rules: [{required: true, message: `To Linked Asset is required!`}],
                  initialValue: data && data.toParent && data.toParent.assetCode,
                })(
                  <Select
                    showSearch
                    mode="single"
                    onSelect={this.showMeter}
                    placeholder="Search Asset"
                    disabled={this.props.title === 'EDIT'}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {this.props.parentAssets && this.props.parentAssets.map(item =>
                      <Option key={item._id} value={item._id}>{item.assetCode}</Option>)}
                  </Select>)}
              </Form.Item>
                {/* Job card + ticket grouped together beneath the "To Asset" field. */}
                {this.renderJobCardWithTicket(
                  ((moveTo === 'asset') || (data && data.toParent && data.toParent.assetCode)) && (
                    <Form.Item key={'toParentJobCard'} label={'Asset Job Card'}>
                      {getFieldDecorator('toParentJobCard', {
                        rules: this.jobCardRules('Asset Job Card'),
                        initialValue: data && data.toParentJobCard && data.toParentJobCard.jobCardNo,
                      })(
                        <Select
                          loading={this.props.jobCardsLoading}
                          disabled={title === 'EDIT'}>
                          {
                            this.props.toJobCards && this.props.toJobCards.map(jc =>
                              <Option key={jc._id} value={jc._id}>{jc.jobCardNo}</Option>)
                          }
                        </Select>,
                      )}
                    </Form.Item>
                  ),
                  true,
                )}
              </>
              : ''}

            {title === 'CREATE' ? moveTo === 'asset' && this.state.toMeterVisible && Object.keys(filters).length &&
              <SubList key={'to.readings'} item={filters['to.readings']} form={form}
                       data={data['to'] && data['to']['readings']} title={title}
                       resource={resource}/> : Object.keys(filters).length &&
              <SubList key={'to.readings'} item={filters['to.readings']} form={form}
                       data={data['to'] && data['to']['readings']} title={title} resource={resource}/>
            }

            <Form.Item key={'preparedBy.name'} label={'Prepared By Name'}>
              {getFieldDecorator('preparedBy.name', {
                rules: [{required: true, message: `Prepared By Name is required!`}],
                initialValue: data && data['preparedBy'] && data['preparedBy'].name && data['preparedBy'].name.name,
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['preparedBy.name'] && filters['preparedBy.name'].options.disabledOnEdit) || false}
              >
                {filters['preparedBy.name'] && filters['preparedBy.name']['data'] && filters['preparedBy.name']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['preparedBy.name'] && filters['preparedBy.name'].options && filters['preparedBy.name'].options.master ?
                  <MasterModal resource={resource} item={filters['preparedBy.name'].options.ref} title={'CREATE'}/> : ''
              }
            </Form.Item>

            <Form.Item key={'preparedBy.date'} label={'Prepared By Date'}>
              {getFieldDecorator('preparedBy.date', {
                rules: [{required: false, message: `Prepared By Date is required!`}],
                initialValue: data && data['preparedBy'] && data['preparedBy'].date && moment(data['preparedBy'].date),
              })(<DatePicker disabled={this.props.title === 'EDIT'}/>)}
            </Form.Item>

            <Form.Item key={'approvedBy.name'} label={'Approved By Name'}>
              {getFieldDecorator('approvedBy.name', {
                rules: [{required: true, message: `Approved By Name is required!`}],
                initialValue: data && data['approvedBy'] && data['approvedBy'].name && data['approvedBy'].name.name,
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['approvedBy.name'] && filters['approvedBy.name'].options.disabledOnEdit) || false}
              >
                {filters['approvedBy.name'] && filters['approvedBy.name']['data'] && filters['approvedBy.name']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['approvedBy.name'] && filters['approvedBy.name'].options && filters['approvedBy.name'].options.master ?
                  <MasterModal resource={resource} item={filters['approvedBy.name'].options.ref} title={'CREATE'}/> : ''
              }
            </Form.Item>

            <Form.Item key={'approvedBy.date'} label={'Approved By Date'}>
              {getFieldDecorator('approvedBy.date', {
                rules: [{required: false, message: `Approved By Date is required!`}],
                initialValue: data && data['approvedBy'] && data['approvedBy'].date && moment(data['approvedBy'].date),
              })(<DatePicker disabled={this.props.title === 'EDIT'}/>)}
            </Form.Item>
            {
              filters && filters.documents &&
              <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                            item={filters.documents} form={form} data={data.documents}
                            getDocumentData={this.getDocumentData} isDisabled={title === 'EDIT'}/>
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}
                      disabled={this.props.title === 'EDIT' || false}>
                {this.props.title === 'EDIT' ? 'OK' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
        {/*<Modal*/}
        {/*width={'60%'}*/}
        {/*title={`${activityDetails && activityDetails.activitySerialNo} Activity Details`}*/}
        {/*visible={this.state.showDetails && !this.props.activityLoading}*/}
        {/*onOk={null}*/}
        {/*onCancel={this.handleModalCancel}*/}
        {/*footer={null}*/}
        {/*>*/}
        {/*<Spin spinning={this.props.activityLoading}>*/}
        {/*<Descriptions>*/}
        {/*<Descriptions.Item label="Details">*/}
        {/*{activityDetails && activityDetails.description}*/}
        {/*</Descriptions.Item>*/}
        {/*<Descriptions.Item label="Job Card">*/}
        {/*{activityDetails && activityDetails.jobCardNo}*/}
        {/*</Descriptions.Item>*/}
        {/*<Descriptions.Item label="Complaint">*/}
        {/*{activityDetails && activityDetails.complaint}*/}
        {/*</Descriptions.Item>*/}
        {/*<Descriptions.Item label="Complaint Detail">*/}
        {/*{activityDetails && activityDetails.complaintDetail}*/}
        {/*</Descriptions.Item>*/}
        {/*<Descriptions.Item label="Complaint Date">*/}
        {/*{activityDetails && activityDetails.complaintDate && moment(activityDetails.complaintDate).format('DD/MM/YYYY')}*/}
        {/*</Descriptions.Item>*/}
        {/*<Descriptions.Item label="Asset">*/}
        {/*{activityDetails && activityDetails.assetCode}*/}
        {/*</Descriptions.Item>*/}
        {/*</Descriptions>*/}
        {/*</Spin>*/}
        {/*</Modal>*/}
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
